<template lang="html">
  <div
    :class="[{ 'user-form': true }, { 'custom-scroll': true }]"
    style="overflow: auto"
  >
    <form class="md-layout md-gutter" @submit.prevent="submit">
      <div class="md-layout-item md-size-100">
        <!-- NAME FIELD -->
        <md-field
          :class="{ 'md-error': $v.user.name.$dirty && $v.user.name.$error }"
        >
          <label>Name</label>
          <md-input
            id="name"
            ref="name"
            v-model.trim="$v.user.name.$model"
            name="name"
          ></md-input>
        </md-field>
        <div
          v-if="$v.user.name.$dirty && $v.user.name.$error"
          class="md-caption text-danger"
        >
          <p v-if="!$v.user.name.required">
            Name is required
          </p>
          <p v-if="!$v.user.name.minLength">
            Name is must be at least 3 characters long
          </p>
          <p v-if="!$v.user.name.maxLength">
            Name can not be grater than 15 characters long
          </p>
        </div>
      </div>

      <!-- END NAME FIELD -->

      <!-- EMAIL FIELD -->
      <div class="md-layout-item md-size-100">
        <md-field
          :class="{ 'md-error': $v.user.email.$dirty && $v.user.email.$error }"
        >
          <label>Email</label>
          <md-input
            id="email"
            ref="email"
            v-model.trim="$v.user.email.$model"
            name="email"
          ></md-input>
        </md-field>
        <div
          v-if="$v.user.email.$dirty && $v.user.email.$error"
          class="md-caption text-danger"
        >
          <div v-if="!$v.user.email.required" class="error">
            Email is required
          </div>
          <div v-if="!$v.user.email.email" class="error">
            Invalid email
          </div>
        </div>
      </div>
      <!-- END OF FIELD -->
      <!-- PHONE FIELD -->

      <div v-if="user.rol == 3" class="md-layout-item md-size-100">
        <md-field
          :class="{ 'md-error': $v.user.phone.$dirty && $v.user.phone.$error }"
        >
          <!-- this.isInvalidDidNumber || this.isDidRequired -->
          <label>Cell Phone #</label>
          <md-input
            id="phone"
            ref="phone"
            v-model.trim="$v.user.phone.$model"
            v-mask="'(###) ###-####'"
            name="phone"
            maxlength="14"
            :disabled="false"
          ></md-input>
        </md-field>
        <div v-show="true" class="md-caption ">
          <div
            v-if="$v.user.phone.$dirty && $v.user.phone.$error"
            class="text-danger error"
          >
            <p v-if="!$v.user.phone.maxLength">
              Cell Phone can not be greater than 14 characters long
            </p>
            <p v-if="!$v.user.phone.minLength">
              Cell Phone can not be less than 14 characters long
            </p>
            <p v-if="!$v.user.phone.validphone">
              Cell Phone must be a valid phone number
            </p>
          </div>
        </div>
      </div>
      <!-- END PHONE FIELD FIELD -->

      <!-- DID FIELD -->
      <div v-if="user.rol == 3" class="md-layout-item md-size-100">
        <md-field
          :class="{ 'md-error': $v.user.did.$dirty && $v.user.did.$error }"
        >
          <!-- this.isInvalidDidNumber || this.isDidRequired -->
          <label>Telabook Phone #</label>
          <md-input
            id="did"
            ref="did"
            v-model.trim="$v.user.did.$model"
            v-mask="'(###) ###-####'"
            name="did"
            maxlength="14"
            :disabled="false"
            @keyup.enter="validateDidNumber($event)"
          ></md-input>
        </md-field>
        <div v-show="true" class="md-caption ">
          <div
            v-if="$v.user.did.$dirty && $v.user.did.$error"
            class="text-danger error"
          >
            <!-- this.isDidRequired -->
            <p v-if="!$v.user.did.maxLength" class="mb-0">
              Telabook Phone can not be greater than 14 characters long
            </p>
            <p v-if="!$v.user.did.minLength" class="mb-0">
              Telabook Phone can not be less than 14 characters long
            </p>
            <p v-if="!$v.user.did.validphone">
              Telabook Phone must be a valid phone number
            </p>
            <p v-if="!$v.user.did.required">
              Telabook Phone is required
            </p>
          </div>
        </div>
      </div>
      <!-- END DID FIELD -->

      <!-- PASSWORD  -->
      <div v-if="user.id == null" class="md-layout-item">
        <div class="password-row ">
          <!--Field-->
          <div class="password-field">
            <md-field
              :class="{
                'md-invalid':
                  $v.user.password.$invalid && $v.user.password.$dirty
              }"
            >
              <label>Password</label>
              <md-input
                id="password"
                ref="password"
                v-model.trim="$v.user.password.$model"
                type="password"
                name="password"
              ></md-input>
            </md-field>
          </div>

          <!--Generate automatically-->

          <div class="password-actions">
            <md-button
              class=" md-primary md-just-icon"
              @click="generatePassword()"
            >
              <md-icon>
                autorenew
              </md-icon>
            </md-button>
          </div>
        </div>
        <div v-if="$v.user.password.$dirty && $v.user.password.$error" class="">
          <div v-if="!$v.user.password.required" class="md-caption text-danger">
            Password is required
          </div>
        </div>
      </div>
      <!-- END OF PASSWORD -->

      <!-- SEND EMAIL -->
      <div v-if="user.id == null" class="md-layout-item md-size-100">
        <md-checkbox v-model="user.send_password_email"
          >Notify user
        </md-checkbox>
      </div>
      <!-- SEND EMAIL -->

      <!-- USER ROL -->
      <div class="md-layout-item md-size-100">
        <md-field
          :class="{
            'md-error': $v.user.rol.$invalid && $v.user.rol.$dirty
          }"
        >
          <label for="">Role*</label>

          <md-select
            id="rol"
            ref="rol"
            v-model="user.rol"
            name="rol"
            style="wigth:100%"
            @md-selected="selectedChangeUserRol($event)"
          >
            <span v-for="item in roles" :key="item.id">
              <md-option :value="item.id">
                {{ item.role }}
              </md-option>
            </span>
          </md-select>
        </md-field>
        <div
          v-if="$v.user.rol.$invalid && $v.user.rol.$dirty"
          class="md-caption text-danger"
        >
          <div v-if="!$v.user.rol.required" class="md-error">
            Role is required
          </div>
        </div>
      </div>
      <!-- END USER ROL -->

      <!-- RATES -->
      <div
        v-if="user.rol == 3"
        class="md-layout-item md-small-size-100 md-xsmall-size-100"
      >
        <div
          class="md-layout md-layout-nowrap md-gutter md-alignment-center-space-between"
          style="flex-wrap:wrap;"
        >
          <div class="md-layout-item md-size-100">
            <span class="md-caption">
              Rates
            </span>
          </div>
          <div class="md-layout-item md-size-80">
            <md-autocomplete
              v-model="rateName"
              placeholder="Select a rate to add"
              style="margn-top:0px"
              md-layout="box"
              class="search"
              :md-options="parsedRates"
              @md-selected="selectedRate = $event"
            >
              <label for="">Rates</label>
              <template slot="md-autocomplete-item" slot-scope="{ item }">
                <p class="m-0">
                  {{ item.name }}
                </p>
              </template>
              <template slot="md-autocomplete-empty" slot-scope="{ term }"
                >No rates found for: {{ term }}
              </template>
            </md-autocomplete>
          </div>
          <div class="md-layout-item md-size-20">
            <md-button
              type="button"
              class="md-primary"
              @click="addToRates(selectedRate)"
            >
              ADD
            </md-button>
          </div>
        </div>
        <div v-if="parsedRates.length === 0">
          No rates have been added, click
          <router-link :to="{ name: 'Rates' }"> here</router-link> to add some
        </div>

        <div class="md-layout md-gutter mt-4">
          <div
            v-for="(rate, index) in selectedRates"
            :key="rate.id"
            class="md-layout-item md-size-100 "
          >
            <div style="display:flex;justify-content:space-between">
              <p>
                {{ rate.name }}
              </p>
              <md-button class="md-simple md-danger" @click="removeRate(index)">
                <md-icon>
                  close
                </md-icon>
              </md-button>
            </div>
          </div>
          <div
            v-if="selectedRates.length == 0"
            class="md-layout-item md-caption mb-4"
          >
            No rates selected
          </div>
        </div>
      </div>
      <!-- END OF RATES -->
      <!-- TIME ZONE -->
      <div
        class="md-layout-item md-small-size-100 md-size-100 md-xsmall-size-100"
      >
        <md-autocomplete
          id="timezone"
          ref="timezone"
          v-model="user.timezone"
          style="margn-top:0px"
          name="timezone"
          :md-options="timeZones"
          :class="{
            'md-invalid': $v.user.timezone.$invalid && $v.user.timezone.$dirty
          }"
        >
          <label>Time zone</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">
            <p class="m-0">
              {{ item.name }}
            </p>
          </template>
        </md-autocomplete>

        <div
          v-if="$v.user.timezone.$dirty && $v.user.timezone.$error"
          class="md-caption text-danger"
        >
          <div v-if="!$v.user.timezone.required" class="md-error">
            Timezone is required
          </div>
        </div>
      </div>
      <!-- TIME ZONE -->

      <div class="md-layout-item">
        <div class="md-layout ">
          <md-button type="submit" class="md-primary mr-4">
            {{ user.id == null ? 'Create User' : 'Update user' }}
          </md-button>

          <md-button
            v-if="user.id == null"
            type="buttom"
            class="md-danger"
            @click="onCancel()"
          >
            Cancel
          </md-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import json from '../../timezones.json'
import roles from '@/api/roles.js'
import ratesApi from '@/api/rates.js'
import userApi from '@/api/users.js'
import {
  helpers,
  required,
  email,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'
import { PHONE_FORMAT } from '@/config/config.js'
const validPhone = helpers.regex('validphone', PHONE_FORMAT)
function makeHash(length) {
  var result = ''
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export default {
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          id: null,
          role: null,
          name: null,
          email: null,
          did: null,
          phone: null,
          password: makeHash(15),
          rates: [],
          send_password_email: true,
          timezone: null
        }
      }
    }
  },
  data: () => ({
    rates: [],
    roles: [],
    isDisabledbtn: false,
    editPassword: false,
    role_id: null,
    rateName: '',
    timezoneName: '',
    showPassword: false,
    selectedRate: null,
    selectedRates: [],
    send_password_email: false,
    zone: null,
    timeZones: [],
    isShowFieldDID: false,
    isInvalidDidNumber: false,
    regex: /(\d{0,3})(\d{0,3})(\d{0,4})/,
    isDidRequired: false
  }),
  validations() {
    let validations = {
      user: {
        password: {
          required
        },
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(15)
        },
        rol: {
          required
        },
        email: {
          required,
          email
        },
        did: {
          validPhone,
          minLength: minLength(14),
          maxLength: maxLength(14)
        },
        phone: {
          validPhone,
          minLength: minLength(14),
          maxLength: maxLength(14)
        },
        timezone: {
          required
        }
      }
    }

    if (this.user.id || this.user.send_password_email) {
      validations.user.password = {}
    }
    if (this.user.rol == 3) {
      validations.user.did = { ...validations.user.did, required }
    }

    return validations
  },
  computed: {
    parsedRates() {
      return this.rates.map(x => ({
        ...x,
        toLowerCase() {
          return this.name.toLowerCase()
        },
        toString() {
          return this.name.toString()
        }
      }))
    },
    ratesValid() {
      if (this.user.rol === 3) {
        if (this.user.rates.length == 0) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  },
  watch: {},
  mounted() {
    this.loadRoles()
    this.timeZones = json.map(x => {
      return {
        ...x,
        name: x.utc + ' ' + x.value,
        toLowerCase() {
          return this.name.toLowerCase()
        },
        toString() {
          return this.name.toString()
        }
      }
    })

    if (this.user.rol === 3) {
      this.isShowFieldDID = true
      if (this.user.did) {
        var phonTemp = this.user.did
        var phone = phonTemp.substring(2, this.user.did.length)
        this.user.did = this.getFormattedNumber(phone)
      }
    }
  },
  created() {
    this.loadRoles()
    this.loadRates()
  },
  methods: {
    setEditPassword() {
      this.password = ''
      this.editPassword = false
    },
    loadRates() {
      ratesApi
        .index({
          quantity: 9999,
          page: 1,
          orderBy: 'name',
          orderFlow: 'desc'
        })
        .then(response => {
          this.rates = response.data.data
          this.selectedRates = this.rates.filter(x =>
            this.user.rates.includes(x.id)
          )

          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadRoles() {
      roles
        .index({})
        .then(response => {
          console.log('ROLES', response.data)
          this.roles = response.data.roles
        })
        .catch(error => {
          this.$emit('error', error.response.data.message)
        })
    },
    udpate_zone(newValue) {
      this.user.timezone = newValue
    },
    submit() {
      /*
      if (this.user.rol === 3 && this.selectedRates.length === 0) {
        this.$notify({
          message: `You must add at least one rate type for an egent`,
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger '
        })
        return false
      }*/
      this.$v.$touch()
      /*
      if (this.isShowFieldDID) {
        if (this.user.did) {
          this.isDidRequired =
            this.user.did.toString().trim().length > 0 ? false : true
        } else this.isDidRequired = true

        if (this.isDidRequired) {
          this.isInvalidDidNumber = false
          this.$emit('error', 'Need to provide agent DID number...')
          return
        }
      }*/
      console.log('IS FORM valid', this.$v.$invalid)
      if (!this.$v.$invalid) {
        this.$emit('saving', true)
        this.user.rates = this.selectedRates.map(x => x.id)

        const promise =
          this.user.id != null
            ? userApi.update({
                ...this.user,
                did: this.user.did
                  ? `+1${this.getNumbersInString(this.user.did)}`
                  : null
              })
            : userApi.save({
                ...this.user,
                createuser: this.howcreateuser == 'direct' ? true : false,
                did: this.user.did
                  ? `+1${this.getNumbersInString(this.user.did)}`
                  : null
              })
        promise
          .then(response => {
            this.$emit('saved', response.data.message)
          })
          .catch(error => {
            console.log(error.response)
            this.$emit('saving', false)
            let message = `${error.response.data.message}`

            if (
              error.response &&
              error.response.data &&
              error.response.data.errors
            ) {
              let errors = error.response.data.errors
              Object.keys(errors).forEach(key => {
                message = `${message} <br> ${errors[key]}`
              })
            }
            this.$emit('error', message)
          })
      }
    },
    addToRates(item) {
      console.log(item)
      let index = this.selectedRates.findIndex(x => x.id == item.id)
      if (index == -1) {
        this.selectedRates.push(item)
        this.rateName = ''
      }
    },
    removeRate(index) {
      this.selectedRates.splice(index, 1)
    },
    onCancel() {
      this.$emit('cancel', true)
    },
    generatePassword() {
      this.user.password = makeHash(10)
    },
    // Method to extract numbers from a text string
    getNumbersInString(chain) {
      if (!chain) {
        return
      }
      var tmpChain = chain.split('')
      var traverseChain = tmpChain.map(function(current) {
        if (!isNaN(parseInt(current))) {
          return current
        }
      })
      var numbers = traverseChain.filter(function(value) {
        return value != undefined
      })

      return numbers.join('')
    },
    // Method for formatting a US phone number
    getFormattedNumber(value) {
      let x = value
        .toString()
        .trim()
        .replace(/\D/g, '')
        .match(this.regex)
      return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    },
    // mask
    setMaskDidNumber($event) {
      if ($event.target.value) {
        $event.target.value = this.getFormattedNumber(
          this.getNumbersInString(this.user.did)
        )
        // this.validateDidNumber( $event.target.value );
        return
      }
      this.isInvalidDidNumber = false
      this.isDidRequired = true
    },
    //
    selectedChangeUserRol($event) {
      if ($event === 3) {
        this.isShowFieldDID = true
      } else {
        this.isShowFieldDID = false
      }
    },
    validateDidNumber(event) {
      if (event) {
        this.isDidRequired = false
        this.isInvalidDidNumber = false
        let auxNumber = this.getNumbersInString(event)
        if (auxNumber.length === 0) this.isDidRequired = true
        else
          auxNumber.length === 10
            ? (this.isInvalidDidNumber = false)
            : (this.isInvalidDidNumber = true)
        return
      }
      this.isInvalidDidNumber = false
      this.isDidRequired = true
    },
    //
    setDisabledDidNumberField($event) {
      console.log($event)
      if (this.user.id) {
        if (this.user.did) {
          return true
        } else return false
      }

      return false
    }
  }
}
</script>
<style lang="scss">
.user-form {
  padding: 0 1.8rem 1rem;
  .md-checkbox .md-checkbox-label {
    color: #000;
  }
}
.password {
  &-row {
    display: flex;
    flex-wrap: wrap;
  }
  &-field {
    width: 100%;
  }
  &-actions {
    display: flex;
    align-items: center;
  }
}

@media (min-width: 980px) {
  .password {
    &-row {
      flex-wrap: nowrap;
    }
  }
}
</style>
